import { render, staticRenderFns } from "./ScholarDetail.vue?vue&type=template&id=4c33ca3b&scoped=true&lang=pug&"
import script from "./ScholarDetail.vue?vue&type=script&lang=js&"
export * from "./ScholarDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScholarDetail.vue?vue&type=style&index=0&id=4c33ca3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c33ca3b",
  null
  
)

export default component.exports